import { createContext, FC, ReactNode, useState } from 'react';

export type Language = 'en' | 'de';

export type CustomizationKey =
	| 'FINCREDIBLE_XS2A_LOADING_TEXT'
	| 'BANK_SELECTION_PAGE_TITLE'
	| 'FORWARDING_PAGE_SUBTITLE'
	| 'ACCOUNT_SELECTION_TITLE'
	| 'ACCOUNT_SELECTION_SUBTITLE'
	| 'FINCREDIBLE_XS2A_ERROR_PAGE_TITLE'
	| 'FINCREDIBLE_XS2A_ERROR_PAGE_INFO'
	| 'FINCREDIBLE_XS2A_ERROR_PAGE_SUPPORT_SECTION'
	| 'FINCREDIBLE_XS2A_ERROR_PAGE_SUPPORT_SUBSECTION'
	| 'TECHNICAL_ERROR_PAGE_ADDITIONAL_INFORMATION'
	| 'TECHNICAL_ERROR_PAGE_INFO'
	| 'TECHNICAL_ERROR_PAGE_TITLE';

export type CustomizationsRecord = Record<CustomizationKey, string | JSX.Element>;

export type CustomizationState = {
	[K in Language]?: CustomizationsRecord;
};

export type CustomizationsContextType = {
	customizations: CustomizationState | undefined;
	getCustomization: (key: CustomizationKey, language: Language) => string | JSX.Element | undefined;
};

export const CustomizationsContext = createContext<CustomizationsContextType | null>(null);

interface Props {
	children: ReactNode;
	initialCustomizations?: CustomizationState | undefined;
}

const CustomizationsProvider: FC<Props> = ({ children, initialCustomizations }) => {
	const [customizations] = useState<CustomizationState>(initialCustomizations || {});

	const getCustomization = (key: CustomizationKey, language: Language) => {
		return customizations?.[language]?.[key];
	};

	return (
		<CustomizationsContext.Provider value={{ customizations, getCustomization }}>
			{children}
		</CustomizationsContext.Provider>
	);
};

export default CustomizationsProvider;
